"use client";

import { useProcessStore } from "@/store/useProcessStore";

/**
 * The settlement's card in the process dock — the same pop-up that follows an
 * NFT's or a collection's creation. The dock itself moves it on the socket
 * (`CHAIN_WORK.settleAuction`: queued → running → done, and
 * `auction_settle_failed` → failed / stuck); this only OPENS it, once per
 * auction: for the owner when they choose the winner, for the winner (or the
 * owner on another device) when `set_auction_winner` arrives.
 */
export function openSettlementCard({ auctionId, title, image }: { auctionId: number | string; title: string; image?: string }): string | null {
  const store = useProcessStore.getState();
  const open = store.processes.find(
    (p) => p.chain?.mode === "settleAuction" && String(p.chain.workId) === String(auctionId) && (p.status === "active" || p.status === "uncertain"),
  );
  if (open) return null;
  return store.startChainWork({ mode: "settleAuction", title, image, workId: auctionId });
}
